import { ApiClient } from "./ApiClient";
import { Organization, OrganizationAttributes } from "typings";
import qs from "qs";

const organizationsPath = "/api/v2/organizations";

const getAll = () => {
  return ApiClient().get(organizationsPath);
};

const getById = (
  id: string,
  options?: {
    include: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().get<Organization>(`${organizationsPath}/${id}?${params}`);
};

const edit = (
  organizationId: string,
  attributes: OrganizationAttributes,
  options?: {
    include?: string[];
  },
) => {
  const params = qs.stringify(options, { arrayFormat: "comma" });
  return ApiClient().patch(`${organizationsPath}/${organizationId}?${params}`, {
    data: {
      type: "organizations",
      id: organizationId,
      attributes,
    },
  });
};

export default { getAll, getById, edit };
